  const changeFavoriteButtonPosition = () => {
    const root_style = document.querySelector(':root');
    const list_item = document.querySelector('.grid__item.favorite-product-li');

    const item_width = list_item?.clientWidth;
    const position = item_width + 1;
    root_style.style.setProperty('--favorite-button-position', `${position}px`);
    if (position <= 1) {
      const sp_list_item = document.querySelector('.sp-product-grid ul .grid__item.favorite-product-li');

      const sp_item_width = sp_list_item?.clientWidth;
      const sp_position = sp_item_width + 1;
      root_style.style.setProperty('--favorite-button-position', `${sp_position}px`);
    }
  }
  window.addEventListener('DOMContentLoaded', () => {
    changeFavoriteButtonPosition();
  });
  window.addEventListener('resize', () => {
    changeFavoriteButtonPosition();
  });